import Axios from "axios";
import type { VisitorAdminBulkRejectItem } from "../../../features/Admin/components/visitor-reception-api.logic";
import { postConferenceVisitorReject } from "./conference-visitor-registration-actions.api";
import { postVisitOnlyReject } from "./visit-only-visit-actions.api";

export type VisitorAdminBulkRejectBody = {
  reason?: string;
  items: VisitorAdminBulkRejectItem[];
};

/** Bulk reject via single endpoint when BE §3.6 is available. */
export const postVisitorAdminBulkReject = (body: VisitorAdminBulkRejectBody) =>
  Axios.post("/booking/visitor-admin/registrations/reject", body);

/**
 * Rejects each item via single-id endpoints (shared reason). Used when bulk endpoint
 * is unavailable (404) or during rollout.
 */
export async function postVisitorAdminBulkRejectFallback(
  body: VisitorAdminBulkRejectBody
): Promise<void> {
  const rejectBody =
    body.reason !== undefined && body.reason.length > 0 ? { reason: body.reason } : undefined;

  await Promise.all(
    body.items.map(item => {
      if (item.kind === "place") {
        return postVisitOnlyReject(item.visitId, rejectBody);
      }
      return postConferenceVisitorReject(item.visitorRegistrationId, rejectBody);
    })
  );
}

/** Tries bulk endpoint; falls back to per-item rejects on 404. */
export async function postVisitorAdminBulkRejectWithFallback(
  body: VisitorAdminBulkRejectBody
): Promise<void> {
  try {
    await postVisitorAdminBulkReject(body);
  } catch (error) {
    if (Axios.isAxiosError(error) && error.response?.status === 404) {
      await postVisitorAdminBulkRejectFallback(body);
      return;
    }
    throw error;
  }
}
